import React from 'react'
import './Partners.scss'
import PartnerCard from './PartnerCard/PartnerCard'
import gsap from 'gsap'
import { Flip } from 'gsap/Flip'
import { Container } from 'react-bootstrap'

import logos from './Logos/index'
import textDict from './partnerText'


interface PartnerProps {
	lang: String
}

const Partners: React.FC<PartnerProps> = (props: PartnerProps) => {
	gsap.registerPlugin(Flip)
	const lang = props.lang
	return (<div className='partners'>
		<h1>Partners</h1>
		{lang === 'nl'
			? <p>De huidige studentes, de technische vrouwen van de toekomst, symboliseren kracht en intelligentie. Met vastberadenheid doorbreken ze stereotypes, werken ze aan innovatie en leiden ze met visie. Hun diverse perspectieven en creatieve geest zullen de technologische vooruitgang vormgeven, waardoor een inclusieve en dynamische toekomst ontstaat voor de wereld van wetenschap en techniek. Én wat is nou een betere plek om deze vrouwen van de toekomst te ontmoeten dan in Eindhoven. De stad die ver vooruit loopt op andere steden qua technologische innovatie met de Technische Universiteit Eindhoven en een oneindigheid aan High-Tec bedrijven. Wil jij ook in contact komen met deze vrouwen van de toekomst? Stuur dan een mail naar info@vrouwenindetop.nl. <br></br>De bedrijven en organisaties hieronder delen ook dezelfde visie voor het inspireren van de huidige vrouwelijke studentes en waren je al voor:</p>
			: <p>The current students, the technical women of the future, symbolize strength and intelligence. With determination, they break stereotypes, work on innovation, and lead with vision. Their diverse perspectives and creative minds will shape technological progress, creating an inclusive and dynamic future for the world of science and technology. And what better place to meet these women of the future than in Eindhoven. The city that is far ahead of other cities in technological innovation with the Eindhoven University of Technology and an infinity of High-Tech companies. Do you also want to get in touch with these women of the future? Then send an email to info@vrouwenindetop.nl. <br></br>The companies and organizations below also share the same vision for inspiring current female students and have already joined:</p>
		}
		<div id="partnercardscontainer">
			{lang === 'nl'
				? <Container className='row' id='partnercards'>
					<PartnerCard text={textDict.nl.alliander} image={logos.alliander} name='Alliander'></PartnerCard>
					<PartnerCard text={textDict.nl.capgemini} image={logos.capgemini} name='Capgemini'></PartnerCard>
					<PartnerCard text={textDict.nl.equans} image={logos.equans} name='Equans'></PartnerCard>
					<PartnerCard text={textDict.nl.shell} image={logos.shell} name='Shell'></PartnerCard>
					<PartnerCard text={textDict.nl.demcon} image={logos.demcon} name='Demcon'></PartnerCard>
					<PartnerCard text={textDict.nl.baeken} image={logos.baeken} name='Baeken'></PartnerCard>
					<PartnerCard text={null} image={logos.asml} name='ASML'></PartnerCard>
					<PartnerCard text={null} image={logos.heijmans} name='Heijmans'></PartnerCard>
					<PartnerCard text={null} image={logos.valcon} name='Valcon'></PartnerCard>
					<PartnerCard text={null} image={logos.youngcolfield} name='Young Colfield'></PartnerCard>
				</Container>
				: <Container className='row' id='partnercards'>
					<PartnerCard text={textDict.en.alliander} image={logos.alliander} name='Alliander'></PartnerCard>
					<PartnerCard text={textDict.en.capgemini} image={logos.capgemini} name='Capgemini'></PartnerCard>
					<PartnerCard text={textDict.en.equans} image={logos.equans} name='Equans'></PartnerCard>
					<PartnerCard text={textDict.en.shell} image={logos.shell} name='Shell'></PartnerCard>
					<PartnerCard text={textDict.en.demcon} image={logos.demcon} name='Demcon'></PartnerCard>
					<PartnerCard text={textDict.en.baeken} image={logos.baeken} name='Baeken'></PartnerCard>
					<PartnerCard text={null} image={logos.asml} name='ASML'></PartnerCard>
					<PartnerCard text={null} image={logos.heijmans} name='Heijmans'></PartnerCard>
					<PartnerCard text={null} image={logos.valcon} name='Valcon'></PartnerCard>
					<PartnerCard text={null} image={logos.youngcolfield} name='Young Colfield'></PartnerCard>
				</Container>
			}

		</div>
	</div>)
}

export default Partners